<template>
	<div class="mt-5 lato-bold text-center px-1 pt-5">Para utilizar esta app, escanee el c&oacute;digo QR desde un dispositivo m&oacute;vil</div>
	<div class="mt-3">
		<vue-qrcode :value="baseUrl" type="image/png" :width="400" :color="qrColor" />
	</div>
</template>

<script setup>
import VueQrcode from 'vue-qrcode'; // Asegúrate de que el importe es correcto para la librería que estás usando.
import { ref, onMounted } from 'vue';

// Variables reactivas
const baseUrl = ref('');
const qrColor = ref({
	dark: '#000000',
	light: '#ffffff',
});

// Configuración al montar el componente
onMounted(() => {
	console.log('Checking route and setting base URL');
	// Se opera solo sobre el pathname (no sobre la URL completa) para no romper
	// hostnames que contengan alguna de estas palabras (ej. onboarding-taxit.digiyo.id)
	const cleanPath = window.location.pathname.replace(/\/(qr|onboarding|finished|unauthorized)\/?$/, '/');
	const location = window.location.origin + cleanPath;
	console.log({ location });
	baseUrl.value = location;
	console.log('baseUrl', baseUrl.value);
});
</script>
